export default "__VITE_ASSET__DsRDLMeK__"